import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    getOrganizations,
    getSites,
    shiftConfiguration,
} from '../../redux/apiCalls'
import Modal from '@material-ui/core/Modal'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'
import PublishIcon from '@material-ui/icons/Publish'
import { style } from './ConfigurationPopupStyle'
import { useStyles, useStylesPopUp } from './shiftStyles'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import moment from 'moment'
import { popUpSuccess } from '../../redux/popUpReducer'
import { apiEndpoints, SERVER_PATH } from '../../endpoint-requests/endpoints'
import { dateCategorySuccess } from '../../redux/datesReducer'
import SiteSelectionLoader from './SiteSelectionLoader'
import Close from '@material-ui/icons/Close'
import getAllSites from '../../endpoint-requests/site/fetchSites'
import { sortData } from './SortData'
import DeleteIcon from '@material-ui/icons/Delete';
import { Checkbox, } from '@material-ui/core'
import { setCurrentFromTime } from './utils/setCurrentFromTime'
import Check from '@material-ui/icons/Check'
import withStyles from '@material-ui/core/styles/withStyles'
import { withTranslation } from 'react-i18next'
import withAuthentication from '../../containers/Authentication/withAuthentication'
import withErrorNotification from '../../containers/withErrorNotification'
import customCheckboxRadioSwitch from '../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch'
import SettingsIcon from '@material-ui/icons/Settings';
import ShiftHourPicker from './ShiftHourPicker'
import { store } from '../../redux/store'
import { importantImageUploadSuccess } from '../../redux/shiftImagesReducer'

const INFO_COLOR = '#00acc1'

const ShiftPopup = ({ classes, setIsActive, isActive, apiCall, autoRefreshTimerId, shiftData, setShiftData, shiftList, setShiftList, hoursList, setHoursList, shiftConfigurationData, setShiftConfigurationData, setLoading }) => {

    const organizations = useSelector((state) => state.organizations.organizations)
    const sites = useSelector((state) => state.sites.sites)
    const selectedOrganization = useSelector((state) => state.organizations.currentOrganization)
    const selectedOrganizationId = useSelector((state) => state.organizations.currentOrganizationId)
    const autoRefreshTimeRedux = useSelector((state) => state.shifts.autoRefreshTime)
    const { currentSites, currentSitesNames, currentSitesIds, sitesMachinesIds } = useSelector((state) => state.sites)
    const { fromDate, toDate, currentShift, minimumWashes, importantUpdateImage, dateRange, } = useSelector((state) => state.shifts.shiftConfigurationData ? state.shifts.shiftConfigurationData : {})
    const dispatch = useDispatch()

    const localClasses = useStyles();
    const styleClasses = useStylesPopUp();

    const [minWashCountError, setMinWashCountError] = useState(false)
    const [minWashCountErrorMsg, setMinWashCountErrorMsg] = useState("")
    const [autoRefreshTimeError, setAutoRefreshTimeError] = useState(false)
    const [autoRefreshTimeErrorMsg, setAutoRefreshTimeErrorMsg] = useState("")
    const [shiftSelectionError, setShiftSelectionError] = useState(false)
    const [loaderTimer, setLoaderTimer] = useState(false)
    const [buttonStatus, setButtonStatus] = useState(false)
    const [minWashCount, setMinWashCount] = useState(minimumWashes ? minimumWashes : 0)
    const [autoRefreshTime, setAutoRefreshTime] = useState(autoRefreshTimeRedux ? autoRefreshTimeRedux : 5)
    const [importantImageUpload, setImportantImageUpload] = useState(importantUpdateImage ? importantUpdateImage : "")
    // const [clientImageUpload, setClientImageUpload] = useState(null)
    const [imageError, setImageError] = useState(false)
    const [currentHour, setCurrentHour] = useState(moment().hours())
    const [org, setOrg] = useState(shiftConfigurationData ? shiftConfigurationData.currentOrganizationName : "")
    const [orgId, setOrgId] = useState(shiftConfigurationData ? shiftConfigurationData.organization : "")
    const [localSites, setLocalSites] = useState(sites ? sites : [])
    const [from, setFrom] = useState(fromDate ? fromDate : "")
    const [to, setTo] = useState(toDate ? toDate : "")
    const [dtRange, setDtRange] = useState(dateRange ? dateRange : "")
    const [openHourPicker, setOpenHourPicker] = useState(false)

    //multi-sites
    const [currentSitesArray, setCurrentSitesArray] = useState(shiftConfigurationData ? shiftConfigurationData.currentSites : [])
    const [currentSitesNamesArray, setCurrentSitesNamesArray] = useState(shiftConfigurationData ? shiftConfigurationData.currentSitesNames : [])
    const [currentSitesIdsArray, setCurrentSitesIdsArray] = useState(shiftConfigurationData ? shiftConfigurationData.currentSitesIds : [])
    const [currentSitesMachinesIds, setCurrentSitesMachinesIds] = useState(sitesMachinesIds ? sitesMachinesIds : [])

    useEffect(() => {
        setCurrentHour(moment().hours())
        let itr = moment.twix(new Date(fromDate), new Date(toDate)).iterate('days')
        let range = []
        while (itr.hasNext()) {
            range.push(itr.next().format('YYYY-MM-DD'))
        }
        dispatch(dateCategorySuccess(range))
    }, [])


    useEffect(() => {
        getOrganizations(dispatch).then(organizations => {
            if (organizations && organizations.length === 1) {
                handleOrganization(organizations[0].name, organizations[0].id)
            }
        })
    }, [])

    useEffect(() => {
        if (
            org &&
            currentSitesArray.length !== 0 &&
            dtRange &&
            // importantImageUpload &&
            !imageError &&
            minWashCount !== '' &&
            autoRefreshTime !== '' &&
            !autoRefreshTimeError &&
            !shiftSelectionError
        ) {
            setButtonStatus(false)
        } else {
            setButtonStatus(true)
        }
    }, [org, currentSitesArray, dtRange, importantImageUpload, imageError, minWashCount, autoRefreshTime, autoRefreshTimeError, shiftSelectionError])

    useEffect(() => {
        if (shiftList.length === 0) {
            setShiftSelectionError(true)
        }
        else {
            setShiftSelectionError(false)
        }
    }, [shiftList])

    useEffect(() => {
        //while unmounting we are checking the old and new autoRefreshTime
        //clear only if there is a change in autoRefreshTime
        return () => {
            if (autoRefreshTime !== autoRefreshTimeRedux) {
                clearInterval(autoRefreshTimerId)
            }
        }
    }, [autoRefreshTime])

    useEffect(() => {
        if (shiftConfigurationData) {
            getSites(dispatch, shiftConfigurationData.organization)
        }
    }, [])

    useEffect(() => {
        setShiftList(shiftConfigurationData ? shiftConfigurationData.shifts : [])
    }, [])

    const handleOrganization = (organizationName, organizationId) => {
        setLoaderTimer(true)
        setOrg(organizationName)
        setOrgId(organizationId)

        const getSites = async () => {
            try {
                const sitesData = await getAllSites()
                const filteredSites = sitesData.filter(site => site.organizationId === organizationId)
                filteredSites.sort(sortData)
                if (filteredSites.length !== 0) {
                    setLoaderTimer(false)
                }
                setLocalSites(filteredSites)
                setCurrentSitesArray([])
                setCurrentSitesNamesArray([])
                setCurrentSitesIdsArray([])
                setCurrentSitesMachinesIds([])
            } catch (error) {
                console.log(error);
            }
        }
        getSites()
    }

    const handleMultiSelectSites = (site) => {

        if (currentSitesNamesArray.length === 0) {
            let array = [];
            array.push(site)
            formatSites(array)
            return
        }
        if (!currentSitesNames?.includes(site.name)) {
            if (!currentSitesNamesArray?.includes(site.name)) {
                formatSites([...currentSitesArray, site])
                return
            }
            else {
                const filteredSites = currentSitesArray.filter((currentSite) => currentSite.id !== site.id)
                formatSites(filteredSites)
                return
            }
        }
        if (currentSitesNames?.includes(site.name)) {
            if (!currentSitesNamesArray?.includes(site.name)) {
                formatSites([...currentSitesArray, site])
                return
            }
            else {
                const filteredSites = currentSitesArray.filter((currentSite) => currentSite.id !== site.id)
                formatSites(filteredSites)
                return
            }
        }
        else {
            const filteredSites = currentSitesArray.filter((currentSite) => currentSite.id !== site.id)
            formatSites(filteredSites)
            return
        }
    };

    const formatSites = (filteredSites) => {
        getSitesNames(filteredSites)
        getSitesIds(filteredSites)
        // getSitesMachinesIds(filteredSites)
        setCurrentSitesArray(filteredSites)
    }

    const getSitesNames = (sites) => {
        const siteNames = sites.map((site) => {
            return site.name
        })
        setCurrentSitesNamesArray(siteNames);
    }

    const getSitesIds = (sites) => {
        const siteIds = sites.map((site) => {
            return site.id
        })
        setCurrentSitesIdsArray(siteIds);
    }

    const getSitesMachinesIds = (sites) => {
        let machinesIds = [];

        sites.map((site) => {
            machinesIds = machinesIds.concat(site["machines"])
            return machinesIds
        })
        const result = machinesIds.map((machineId) => {
            return machineId.id
        })
        setCurrentSitesMachinesIds(result)
    }

    const handleDateRange = (e) => {
        let dateArray = e.target.value.split(" ")
        let myDate = moment().subtract(dateArray[0], dateArray[1]);
        myDate = new Date(myDate.format()).toISOString()
        myDate = setCurrentFromTime(myDate)
        setFrom(myDate)
        setTo(new Date().toISOString())
        setDtRange(e.target.value)

        let itr = moment.twix(myDate, new Date(new Date().toISOString())).iterate('days')
        let range = []
        while (itr.hasNext()) {
            range.push(itr.next().format('YYYY-MM-DD'))
        }
        dispatch(dateCategorySuccess(range))
    }

    const validateDimensions = (file) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = async (e) => {
            const image = new Image();
            image.src = e.target.result;
            image.onload = (e) => {
                const height = e.target.height;
                const width = e.target.width;
                if (height !== 720 && width !== 1280) {
                    setImageError(true)
                    return false;
                }
                setImportantImageUpload(file)
                setImageError(false)
                return true;
            };
        };

    }

    const handleImportantImageUpload = (e) => {
        const file = e.target.files[0]
        const requiredFileSize = 5
        const fileSize = file?.size
        const fileSizeMB = fileSize / 1024 / 1024;
        const fileSizeRoundof = Math.round(fileSizeMB * 10) / 10;
        const requiredFileTypes = ["png", "jpg", "jpeg"]
        let selectedFileType = file?.type.split("/")[1];
        if (requiredFileTypes.includes(selectedFileType) && fileSizeRoundof < requiredFileSize) {
            validateDimensions(file)
        }
        else {
            setImageError(true)
        }
    }
    const handleDelete = () => {
        dispatch(importantImageUploadSuccess(""))
    }

    const handleClose = () => {
        setIsActive(false)
        dispatch(popUpSuccess(false))
    };

    const handleBack = () => {
        setIsActive(false)
        dispatch(popUpSuccess(false))
    }

    const openShiftHourPicker = () => {
        setOpenHourPicker(true)
    }

    const handleSubmit = () => {
        setLoading(true)
        //---clearing old setInterval timer---//
        // clearInterval(autoRefreshTimerId)
        setIsActive(false)
        dispatch(popUpSuccess(false))

        let data = new FormData();
        data.append('organization', orgId);
        data.append('currentShift', 2);
        data.append('sites', currentSitesIdsArray);
        data.append('minimumWashes', minWashCount);
        data.append('autoRefreshTime', Number(autoRefreshTime));
        // data.append('clientLogo', clientImageUpload);
        data.append('importantUpdateImage', importantImageUpload);
        data.append('dateRange', dtRange);
        data.append('shifts', shiftList);
        data.append('currentHour', moment().hours());

        var config = {
            method: 'post',
            url: SERVER_PATH + apiEndpoints.shiftConfiguration,
            data: data,
            withCredentials: true
        };
        shiftConfiguration(dispatch, config, setShiftConfigurationData, setLoading)
    }
    return (
        <>
            {
                openHourPicker && <ShiftHourPicker openHourPicker={openHourPicker} setOpenHourPicker={setOpenHourPicker} shiftData={shiftData} setShiftData={setShiftData} currentHour={currentHour} hoursList={hoursList} setHoursList={setHoursList} shiftList={shiftList} setShiftList={setShiftList} />
            }
            <Modal
                open={isActive}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <h3>Shift Configuration</h3>
                    <Close onClick={handleClose}
                        className={styleClasses.myClassName}
                    />
                    <div style={{
                        display: 'flex', alignItems: 'center', flexDirection: 'column',
                        overflowY: "auto",
                        // maxHeight: "386px",
                        overflowX: "hidden",
                        width: "100%"
                    }}>
                        {organizations.length > 1 &&
                            <div className="configurationPopup">
                                <FormControl className={localClasses.formControl}>
                                    <InputLabel id="mutiple-select-label" style={{ fontSize: '14px' }}>Select
                                        Organizations</InputLabel>
                                    <Select
                                        value={org}
                                        style={{ width: '350px', fontSize: '14px', }}
                                    >
                                        {organizations.map((organization) => (
                                            <MenuItem key={organization.id} value={organization.name}
                                                onClick={() => handleOrganization(organization.name, organization.id)}
                                            >
                                                <ListItemText
                                                    primary={organization.name} localClasses={{ primary: localClasses.selectAllText }} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>}
                        {
                            org !== "" && loaderTimer === true ? <SiteSelectionLoader /> :
                                <>
                                    <div className="configurationPopup" >
                                        <FormControl className={localClasses.formControl}>
                                            <InputLabel id="mutiple-select-label" style={{ fontSize: "14px" }}>Select Sites</InputLabel>
                                            <Select
                                                value={currentSitesArray}
                                                style={{ width: "350px", fontSize: "14px" }}
                                                labelId="demo-multiple-checkbox-label"
                                                id="demo-multiple-checkbox"
                                                multiple
                                                renderValue={(currentSitesArray) => currentSitesArray.map((item) => item.name)?.join(", ")}
                                            >
                                                {localSites.map((site) => (
                                                    <MenuItem key={site.id}
                                                        value={site}
                                                        onClick={() => handleMultiSelectSites(site)} >
                                                        <Checkbox
                                                            id="editSiteDistributorSelectCheckbox"
                                                            checked={currentSitesArray.find((currentSite) => currentSite.id === site.id) !== undefined}
                                                            checkedIcon={<Check
                                                                className={classes.checkedIcon}
                                                                style={{ color: INFO_COLOR }}
                                                            />}
                                                            icon={<Check
                                                                className={classes.uncheckedIcon}
                                                            />}
                                                        />

                                                        <ListItemText
                                                            primary={site.name} localClasses={{ primary: localClasses.selectAllText }} selected={true} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </>
                        }
                        <div className="configurationPopup" >
                            <FormControl className={localClasses.formControl}>
                                <InputLabel htmlFor="demo-simple-select-label"
                                    style={{ fontSize: "14px" }}
                                >Select Date Range</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="fromDate"
                                    value={dtRange}
                                    onChange={(e) => handleDateRange(e)}
                                    style={{ width: "350px", fontSize: "14px" }}
                                >
                                    <MenuItem value="1 weeks">Week</MenuItem>
                                    <MenuItem value="2 weeks">2 Weeks</MenuItem>
                                    <MenuItem value="3 weeks">3 Weeks</MenuItem>
                                    <MenuItem value="1 months">1 Month</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        {/* <div className="configurationPopup2" >
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Upload Client's Logo
                            </Typography> */}
                        {/* for in label tag must same as id in input tag */}
                        {/* <label for="file1">
                                <PublishIcon />
                            </label>
                            <input
                                type="file"
                                id="file1"
                                style={{ display: "none", }}
                                onChange={handleClientImageUpload}
                            />
                        </div> */}
                        <div style={{ width: "350px", marginTop: 15, marginBottom: 15, }}>
                            <span style={{ fontSize: "15px", }}>1280x720, png/jpg/jpeg</span>
                            <div className="configurationPopup2" style={{ display: "flex", justifyContent: "space-between" }}>
                                <div>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ marginRight: "40px", }}>
                                        Upload Image
                                    </Typography>
                                </div>
                                {/* for in label tag must same as id in input tag */}
                                <div>
                                    <label for="file2" style={{ cursor: 'pointer', color: '#3c4858', }}>
                                        <PublishIcon style={{ color: "black", }} />
                                    </label>
                                    {
                                        importantImageUpload && <DeleteIcon style={{ color: "red", cursor: 'pointer', marginLeft: "10px" }} onClick={() => handleDelete()} />
                                    }
                                    <input
                                        type="file"
                                        id="file2"
                                        style={{ display: "none", }}
                                        onChange={handleImportantImageUpload}
                                    />
                                </div>

                            </div>
                            {imageError && <p style={{ color: "red" }} >Invalid Upload</p>}
                        </div>
                        <div style={{ width: "350px", display: "flex", justifyContent: "space-between", alignItems: "center", margin: "10px" }}>
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Current Shifts*
                            </Typography>
                            <SettingsIcon onClick={() => openShiftHourPicker()} style={{ width: "30px", height: "30px", cursor: "pointer" }} />
                        </div>
                        {shiftSelectionError && <p style={{ color: "red", marginLeft: "-224px", marginTop: "-15px" }} >Please create shifts</p>}
                        <div className="configurationPopup" >
                            <TextField
                                onChange={(e) => {
                                    const re = /^[0-9\b]+$/;
                                    if (e.target.value === "") {
                                        setMinWashCountError(true);
                                        setMinWashCountErrorMsg("Please select number of washes")
                                    }
                                    else {
                                        setMinWashCountError(false);
                                        setMinWashCountErrorMsg("")
                                    }
                                    if (e.target.value === "" || re.test(e.target.value)) {
                                        setMinWashCount((e.target.value).substring(0, 5))
                                    }
                                }}
                                inputProps={{ style: { width: 350, fontSize: 20 } }}
                                value={minWashCount}
                                className="textField" placeholder="Minimum Shift Count"
                                label="Target Number of Washes"
                                error={minWashCountError}
                                helperText={minWashCountErrorMsg}
                                maxLength={5}
                            />
                        </div>
                        <div className="configurationPopup" >
                            <TextField
                                onChange={(e) => {
                                    const re = /^[0-9\b]+$/;
                                    if (e.target.value === "") {
                                        setAutoRefreshTimeError(true);
                                        setAutoRefreshTimeErrorMsg("Please enter auto refresh time")
                                    }
                                    if (Number(e.target.value) < 1) {
                                        setAutoRefreshTimeError(true);
                                        setAutoRefreshTimeErrorMsg("Auto Refresh Time must not be less than 1")
                                    }
                                    else {
                                        setAutoRefreshTimeError(false);
                                        setAutoRefreshTimeErrorMsg("")
                                    }
                                    if (e.target.value === "" || re.test(e.target.value)) {
                                        setAutoRefreshTime(Number((e.target.value).substring(0, 2)))
                                    }
                                }}
                                inputProps={{ style: { width: 350, fontSize: 20 } }}
                                value={autoRefreshTime}
                                className="textField" placeholder="Auto Refresh Time"
                                label="Auto Refresh Time (Minutes)"
                                error={autoRefreshTimeError}
                                helperText={autoRefreshTimeErrorMsg}
                                maxLength={2}
                            />
                        </div>
                    </div>
                    <div className="popupButtonDiv">
                        <Button variant="contained" style={{ cursor: 'pointer' }} onClick={() => handleBack()}>Back</Button>
                        <Button variant="contained" style={{ cursor: 'pointer' }} onClick={() => handleSubmit()}
                            disabled={buttonStatus}
                        >Save</Button>
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default withErrorNotification(withAuthentication(withStyles(customCheckboxRadioSwitch)(withTranslation()(ShiftPopup))))




